export const updateRewardCodeCount = () => {
  if ($('#certificate-pass-promo-code').length > 0) {
    const grabCountAndReplace = (code) => {
    	if($(code).val().length > 0){
    		 $('#codeCount').show();
    	} else {
         $('#codeCount').hide();
    	}
      let remaining = 30 - $(code).val().length;
      $('#codeRemaining').text(remaining);
    }
    grabCountAndReplace('#certificate-pass-promo-code');
    $('#certificate-pass-promo-code').on('input', function() {
      var maxRewardInput = 30;
      $(this).val($(this).val().replace(/[^a-zA-Z0-9]+/g, ""));
      if ($(this).val().length >= 30) {
        $(this).val($(this).val().substring(0, maxRewardInput));
      }
      grabCountAndReplace(this);
    });
  }
}
 